export default {
  newDesign: true,
  parameters: {
    landing_id: "LatQC10",
    segment: 14,
  },
  title:
    "Responde a 10 preguntas y recibe una clase gratuita para tu hijo/a de 8 a 17 años | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      type: "age-start",
      title: "¿Cuántos años tiene tu hijo?",
      image: {
        url: "/welcome/peru_1_start_immediate_desk.png",
      },
      imageMobile: {
        url: "/welcome/peru_1_start_immediate_mob.png",
      },
    },
    2: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: [
        "🔥 ¡Si!",
        "🤗 No. Lo hace solo para divertirse y eso está bien",
      ],
    },
    3: {
      question: "En la escuela, ¿qué es lo que más disfruta tu hijo?",
      answers: [
        "🧪🔢 Ciencias o matemáticas",
        "📚✍️ Leer y escribir historias",
        "🎨🎶 Arte, música o actividades creativas",
        "🏃‍♀️🏋️‍♂️ Educación física o deportes",
        "🙂 Otro ",
      ],
    },
    4: {
      question: "¿Qué tipo de actividades o pasatiempos atraen más a tu hijo?",
      answers: [
        "⚽ Deportes o baile",
        "🎨🖌️ Artes creativas",
        "🧩♟️💻 Dibujo, pintura o manualidades",
        "🎮📺 Videojuegos o ver videos",
        "🙂 Otro",
      ],
    },
    5: {
      title: "¿Quiénes somos?",
      typeInfo: "noQuestions",
      subtitle:
        "Kodland es una plataforma educativa en línea para niños de 5 a 17 años. Nuestros estudiantes adquieren habilidades digitales convirtiendo sus sueños en proyectos reales.",
      imageLink: "/welcome/latam_fwd_start_pc.png",
      button: "Continuemos",
    },
    6: {
      question: "¿Tu hijo ha mostrado interés en aprender a programar?",
      answers: [
        "💻🚀 Sí, ya ha empezado a aprender",
        "🤔💡 Sí, tiene curiosidad, pero no lo ha intentado",
        "🤷‍♂️ Aún no, pero tal vez se interese",
        "🙅‍♀️ No, no está interesado",
      ],
    },
    7: {
      question:
        "En estos momentos, ¿qué es lo más importante para ti en el desarrollo de tu hijo/a?",
      answers: [
        "🤔 Habilidades blandas",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    8: {
      question: "¿Cómo se siente tu hijo con respecto al aprendizaje en línea?",
      answers: [
        "💻 Le encanta y lo encuentra interesante",
        "🙂 Prefiere el aprendizaje presencial",
        "😅 Le cuesta mantener la concentración",
        "❓ Nunca ha intentado aprender en línea",
      ],
    },
    9: {
      title: "Aprende más rápido con Kodland",
      typeInfo: "noQuestions",
      subtitle:
        "Gracias a clases interactivas y el apoyo personalizado de un mentor, tu hijo comprenderá los temas más rápido y los recordará por más tiempo.",
      imageLink: "/welcome/latam_fwd_graf_pc.png",
      button: "Empieza ahora",
    },
    10: {
      question:
        "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
    11: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "🔥 Casi terminamos",
    },
    12: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    13: {
      title: "✨ Revisa estos detalles para completar el registro",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    14: {
      title: "📞 Chequea tu correo y WhatsApp antes de la clase de prueba",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    15: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
